import { useState } from "react";
import { Col, Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import loadingLogo from "../assets/loading-logo.png";

const StoreCard = (props) => {
  const [isLogoLoading, setIsLogoLoading] = useState(true);
  const store = props.store;
  return (
    <Col xs={6} sm={6} md={4} lg={3} xl={2} className="my-2">
      <Card className="text-center h-100">
        <Link to={`/stores/${store.slug}`}>
          <Card.Img
            variant="top"
            src={loadingLogo}
            alt={`${store.nameEn} logo`}
          />
          <Card.Img
            variant="top"
            src={store.logo}
            alt={`${store.nameEn} logo`}
            style={{
              visibility: isLogoLoading ? "hidden" : "visible",
              position: "absolute",
              top: 0,
              right: 0,
            }}
            onLoad={() => setIsLogoLoading(false)}
          />
        </Link>
        <Card.Body className="d-flex flex-column justify-content-between">
          <Card.Title style={{ backgroundColor: "#fff0e6" }}>
            <Link to={`/stores/${store.slug}`} style={{ color: "black" }}>
              {store.nameAr} {store.nameEn}
            </Link>
          </Card.Title>
        </Card.Body>
      </Card>
    </Col>
  );
};

export default StoreCard;
